<template>
  <div>
    <!-- modal to create new flashcarddeck -->
    <!-- <div v-if="!flashcardDeckEditor" @click="returnToDeckList()" class="modal no-select"> -->
    <div v-if="!flashcardDeckEditor" @click="returnToDeckList()" class="modal no-select">
      <div class="modal-content" @click.stop=";">
        <h3 class="has-text-left">Add New Flashcard Deck</h3>
        <p class="new-name-text has-text-left">Enter a name for the deck:</p>
        <form v-on:submit.prevent="openFlashcardDeckEditor(); newFlashcardDeck = true;">
          <input
            type="text"
            class="focusable"
            v-model="currentFlashcardDeckTitle"
            maxlength="100"
            placeholder="Name"
          />
        </form>
        <div class="modal-buttons is-pulled-right">
          <button v-on:click.stop="returnToDeckList()" class="button">Cancel</button>
          <button
            v-on:click.stop="openFlashcardDeckEditor(); newFlashcardDeck = true;"
            :disabled="currentFlashcardDeckTitle.length <= 0"
            class="button is-primary"
          >Create</button>
        </div>
      </div>
    </div>

    <!-- FlashcardEditor -->
    <div
      v-if="flashcardDeckEditor"
      class="popup-flashcard-editor"
      v-bind:class="{'popup-flashcard-editor-modal-view' : modalView}"
    >
      <div class="flashcard-header-title">
        <div class="tr">
          <div class="flashcarddeck-editor-title">
            <div v-show="!editTitleMode">
              <div
                v-on:click.stop="flashcardDeckTitleFocus()"
                class="editor-title"
              >{{ currentFlashcardDeckTitle ? utils.truncateStringAccordingToWidth(currentFlashcardDeckTitle, getWidth(0.83)) : "" }}</div>
            </div>
            <div v-show="editTitleMode">
              <input
                ref="flashcardDeckTitle"
                v-model="currentFlashcardDeckTitle"
                v-on:blur="updateflashcardDeckTitle()"
                class="flashcard-deck-title"
              />
            </div>
          </div>
          <div class="flashcard-right-tools">
            <div class="flashcard-right-tool">
              <div @click="saveAndClose(false)" class="icon-button">
                <i class="fal fa-play"></i>
              </div>
            </div>
            <div class="flashcard-right-tool">
              <div @click="addFlashcard()" class="icon-button">
                <i class="fal fa-plus"></i>
              </div>
            </div>
            <div class="flashcard-right-tool">
              <Popover
                v-bind:class="{'disabled': totalFlashcards <= 1}"
                ref="removeFlashcard"
                placement="bottom"
                :disabled="totalFlashcards <= 1"
                :width="270"
              >
                <div @click=";" class="icon-button">
                  <i class="fal fa-trash-alt"></i>
                </div>
                <div slot="content">
                  <div class="delete-message">Remove this flashcard from the deck?</div>
                  <div class="popover-buttons">
                    <button v-on:click.stop="closeDeletePopover()" class="button is-primary">No</button>
                    <button v-on:click.stop="deleteFlashcard()" class="button is-pulled-right">Yes</button>
                  </div>
                </div>
              </Popover>
            </div>
          </div>
        </div>
      </div>
      <div class="flashcards">
        <div class="flashcard">
          <span class="textarea-label no-select">Front</span>
          <slot
            v-if="flashcardDeck && flashcardDeck.flashCards && flashcardDeck.flashCards.length > 0"
          >
            <div class="flashcard-textarea">
              <textarea
                v-model="flashcardDeck.flashCards[currentFlashcard-1].front"
                :disabled="flashcardEditorSelectText !== ''"
                :class="{'copy-color': flashcardEditorSelectText}"
                class="flashcard-textarea-input"
                id="flashcard-front"
                placeholder="Enter text"
              ></textarea>
              <div v-if="flashcardEditorSelectText" class="copy-text">
                <button
                  class="button is-primary"
                  @click="copyText(flashcardDeck.flashCards[currentFlashcard-1], 0)"
                >Use selected text</button>
              </div>
            </div>
          </slot>
          <slot v-else>
            <div class="flashcard-textarea">
              <textarea
                class="flashcard-textarea-input"
                id="placeholder-front"
                placeholder="Enter text"
                rows="5"
              ></textarea>
            </div>
          </slot>
        </div>
        <div class="prev-flashcard-button">
          <div v-if="currentFlashcard > 1" @click="prevFlashcard()" class="prev-flashcard">
            <i class="fal fa-chevron-left"></i>
          </div>
        </div>
        <div class="next-flashcard-button">
          <div class="next-flashcard-button">
            <div v-if="totalFlashcards > 1 && currentFlashcard != totalFlashcards" @click="nextFlashcard()" class="next-flashcard">
              <i class="fal fa-chevron-right"></i>
            </div>
          </div>
        </div>
        <div @click="swapFlashcards()" class="swap-cards icon-button no-select">
          <i class="fal fa-exchange"></i>
          <span class="small-text">Swap</span>
        </div>
        <div class="flashcard">
          <span class="textarea-label no-select">Back</span>
          <slot
            v-if="flashcardDeck && flashcardDeck.flashCards && flashcardDeck.flashCards.length > 0"
          >
            <div class="flashcard-textarea">
              <textarea
                v-model="flashcardDeck.flashCards[currentFlashcard-1].back"
                :disabled="flashcardEditorSelectText !== ''"
                :class="{'copy-color': flashcardEditorSelectText}"
                class="flashcard-textarea-input"
                id="flashcard-back"
                placeholder="Enter text"
              ></textarea>
              <div v-if="flashcardEditorSelectText" class="copy-text">
                <button
                  class="button is-primary"
                  @click="copyText(flashcardDeck.flashCards[currentFlashcard-1], 1)"
                >Use selected text</button>
              </div>
            </div>
          </slot>
          <slot v-else>
            <div class="flashcard-textarea">
              <textarea
                class="flashcard-textarea-input"
                id="placeholder-back"
                placeholder="Enter text"
                rows="5"
              ></textarea>
            </div>
          </slot>
        </div>
      </div>
      <div class="flashcard-footer">
        <div class="tr">
          <div class="empty"></div>
          <div class="page-counter">{{currentFlashcard}}/{{totalFlashcards}}</div>
          <div class="save-and-close">
            <button class="button is-primary" @click="saveAndClose()">Save and Close</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
const _ = require("lodash");
import Vue from "vue";
import utils from "@/utils/utils.js";
import bookUtils from "@/utils/bookUtils.js";
import serverUtils from "@/utils/serverUtils.js";
import storeHelpers from "@/utils/storeHelpers.js";
import analytics from "@/utils/analytics.js";
import Popover from "@/components/widgets/popover";

export default {
  name: "FlashcardEditor",
  components: {
    Popover
  },
  props: {
    currentPage: {
      type: Object
    },
    book: {
      type: Object
    },
    flashcardDeckObject: {
      type: Object
    },
    flashcardDecks: {
      type: Array
    },
    modalView: {
      type: Boolean
    },
    currentFolder: {
      type: Object
    },
    postMyFolderContent: {
      type: Function
    },
    flashcardDeckBeforeEditing: {
      type: Object
    },
    flashcardEditorSelectText: {
      type: String,
      default: ""
    },
    fromContextMenu: {
      type: Boolean
    },
    contextMenuOptions: {
      type: Object
    },
    metadata: {
      type: Object
    }
  },
  data: function() {
    var t = this;
    return {
      utils: utils,
      flashcardDeckEditor: false,
      currentFlashcard: 1,
      totalFlashcards: 1,
      currentFlashcardDeckTitle: "",
      editTitleMode: false,
      newFlashcardDeck: false,
      currentFlashcardDeckId: "",
      flashcardDeck: {},
      noAttachmentUpload: false,
      selector: "",
      section: ""
    };
  },
  mounted() {
    var t = this;
    storeHelpers.checkActive(this);
    t.currentFlashcardDeckTitle = t.flashcardDeckBeforeEditing && t.flashcardDeckBeforeEditing.currentFlashcardDeckTitle ? t.flashcardDeckBeforeEditing.currentFlashcardDeckTitle : "";
    t.flashcardDeck = t.flashcardDeckObject && t.flashcardDeckObject.flashCards ? t.flashcardDeckObject : {
      flashCards: [{
        _id: "flashCard-" + utils.GUID(), front: "", back: "" 
      }]
    };
    t.currentFlashcardDeckId = t.flashcardDeckBeforeEditing && t.flashcardDeckBeforeEditing.currentFlashcardDeckId ? t.flashcardDeckBeforeEditing.currentFlashcardDeckId : "";
    t.flashcardDeckEditor = t.flashcardDeckBeforeEditing && t.flashcardDeckBeforeEditing.flashcardDeckEditor ? true : false;
    t.totalFlashcards = t.flashcardDeck && t.flashcardDeck.flashCards && t.flashcardDeck.flashCards.length > 0 ? t.flashcardDeck.flashCards.length : 1;

    if (t.fromContextMenu) {
      t.selector = t.contextMenuOptions.selector;
      t.section = t.contextMenuOptions.section;
    } else {
      if (t.book && bookUtils.isMPUB(t.book)) {
        var { windowHandle } = bookUtils.getiFrame();
        t.selector = windowHandle.findTopVisibleElement();
        t.section = bookUtils.getCurrentPageObject(t.metadata, t.currentPage.oneBasedIndex).file;
      }
      if (t.book && bookUtils.isPDF(t.book)) {
        t.selector = "0";
        t.section = t.currentPage.oneBasedIndex;
      }
    }

    var t = this;
    document.addEventListener("keydown", function(e) {
      if (e.keyCode === 27) {
        if (!t.flashcardDeckEditor) t.returnToDeckList();
      }
    });
  },
  methods: {
    createNewFlashcardDeck: function(attachment, resource) {
      var t = this;
      if (!t.noAttachmentUpload) {
        serverUtils.uploadAttachment(t, attachment);
        storeHelpers.addAttachment(t, attachment);
        serverUtils.uploadResource(
          t,
          resource,
          JSON.stringify(t.flashcardDeck.flashCards),
          function(res, e) {
            if (res === "200") {
              storeHelpers.addResource(t, resource);
              analytics.flashcardDeck(t, resource.id, 0);
              if (t.currentFolder !== undefined) {
                t.postMyFolderContent();
              }
            } else {
              console.error("Fail uploading resource:", e);
            }
          }
        );
      } else {
        serverUtils.uploadResource(
          t,
          resource,
          JSON.stringify(t.flashcardDeck.flashCards),
          function(res, e) {
            if (res === "200") {
              storeHelpers.addResource(t, resource);
              t.currentFolder.resources.push(resource);
              Vue.set(t.currentFolder, "resources", t.currentFolder.resources);
              analytics.flashcardDeck(t, resource.id, 0);
              if (t.currentFolder !== undefined) {
                t.postMyFolderContent();
              }
            } else {
              console.error("Fail uploading resource:", e);
            }
          }
        );
      }
    },
    updateCurrentFlashcardDeck: function(resource) {
      var t = this;
      serverUtils.uploadResource(
        t,
        resource,
        JSON.stringify(t.flashcardDeck.flashCards),
        function(res, e) {
          if (res === "200") {
            t.$emit("myFolderFlashcardDeckEdit", resource);
            storeHelpers.updateResource(t, resource);
          } else {
            console.error("Fail updating resource");
          }
        }
      );
    },
    saveAndClose: function(close = true) {
      storeHelpers.checkActive(this);
      var t = this;
      var attachment,
        resource = {};
      // if it is a new flashcarddeck create attachment and resource for it
      if (t.newFlashcardDeck) {
        var filename = t.currentFlashcardDeckTitle + ".flashcarddeck";
        if (t.book && bookUtils.isPDF(t.book)) {
          attachment = serverUtils.createAttachment(
            t.book.id,
            t.section,
            t.selector
          );
        } else if (t.book && bookUtils.isMPUB(t.book)) {
          attachment = serverUtils.createAttachment(
            t.book.id,
            t.section,
            t.selector
          );
        } else {
          // flashcard added from my folders
          // create resource
          // upload resource
          t.noAttachmentUpload = true;
        }
        resource = serverUtils.createResource(filename);
        if (attachment) {
          attachment.resource = resource.id;
        }
        t.createNewFlashcardDeck(attachment, resource);
        t.newFlashcardDeck = false;
        t.currentFlashcardDeckId = resource._id;
      } else {
        // use current
        if (t.flashcardDecks) {
          resource = _.find(t.flashcardDecks, function(deck) {
            return deck._id === t.currentFlashcardDeckId;
          });
        } else {
          resource = storeHelpers.getResourceById(t, t.currentFlashcardDeckId);
        }
        if (resource) {
          resource.title = t.currentFlashcardDeckTitle;
          if (
            t.flashcardDeckBeforeEditing.currentFlashcardDeckTitle !==
            t.currentFlashcardDeckTitle
          ) {
            // flashcardDeckRename: function(handle, resourceId, from, to)
            analytics.flashcardDeckRename(
              t,
              resource.id,
              t.flashcardDeckBeforeEditing.currentFlashcardDeckTitle,
              t.currentFlashcardDeckTitle
            );
          }
          t.updateCurrentFlashcardDeck(resource);
        } else {
          console.error("error"); // todo error
        }
      }
      if (close) {
        t.close();
      } else {
        t.openResource(resource);
      }
    },
    close: function() {
      this.flashcardDeckEditor = false;
      this.$emit("flashcardClose", false);
      this.$emit("renameFlashcardDeckInFolder", this.currentFlashcardDeckTitle);
    },
    returnToDeckList: function() {
      this.$emit("returnToDeckList");
      this.flashcardDeckEditor = false;
    },
    openFlashcardDeckEditor: function() {
      var t = this;
      Vue.nextTick(function() {
        t.flashcardDeckEditor = true;
        t.$emit("openFlashcardStyling");
      });
    },
    addFlashcard: function() {
      storeHelpers.checkActive(this);
      this.currentFlashcard += 1;
      this.totalFlashcards += 1;
      var flashcard = {};
      flashcard._id = flashcard._id = "flashCard-" + utils.GUID();
      flashcard.front = "";
      flashcard.back = "";
      this.flashcardDeck.flashCards.splice(
        this.currentFlashcard - 1,
        0,
        flashcard
      );
      analytics.flashcard(
        this,
        this.currentFlashcardDeckId,
        this.flashcardDeck.flashCards[this.currentFlashcard - 1]._id,
        0
      );
    },
    prevFlashcard: function() {
      storeHelpers.checkActive(this);
      if (this.currentFlashcard > 0) {
        this.currentFlashcard -= 1;
      }
    },
    nextFlashcard: function() {
      storeHelpers.checkActive(this);
      if (this.currentFlashcard != this.totalFlashcards) {
        this.currentFlashcard += 1;
      }
    },
    swapFlashcards: function() {
      var temp = this.flashcardDeck.flashCards[this.currentFlashcard - 1].front;
      this.flashcardDeck.flashCards[this.currentFlashcard - 1].front = this.flashcardDeck.flashCards[this.currentFlashcard - 1].back;
      this.flashcardDeck.flashCards[this.currentFlashcard - 1].back = temp;
    },
    deleteFlashcard: function() {
      // flashcard: function(handle, resourceId, flashcardId, action = 0)
      analytics.flashcard(this, this.currentFlashcardDeckId, this.flashcardDeck.flashCards[this.currentFlashcard - 1]._id, 0);

      this.flashcardDeck.flashCards.splice(this.currentFlashcard - 1, 1);

      if (this.totalFlashcards > 1) {
        this.totalFlashcards -= 1;
      }
      if (this.currentFlashcard > 1) {
        this.currentFlashcard -= 1;
      }
      this.closeDeletePopover();
    },
    closeDeletePopover: function() {
      var t = this;
      if (t.$refs.removeFlashcard) {
        t.$refs.removeFlashcard.hidePopper();
      }
    },
    flashcardDeckTitleFocus: function() {
      var t = this;
      t.editTitleMode = true;
      Vue.nextTick(function() {
        t.$refs.flashcardDeckTitle.focus();
      });
    },
    updateflashcardDeckTitle: function() {
      this.editTitleMode = false;
    },
    getWidth: function(percent = 1) {
      return window.innerWidth * percent;
    },
    openResource: function(resource) {
      var optionObj = {
        from: "fe"
      };
      // get attachment for resource
      var attachments = _.filter(this.$store.state.attachments, att => {
        return att.resource === resource._id;
      });

      utils.openResource(
        this,
        resource,
        attachments.length > 0 ? [attachments[0]._id] : undefined,
        optionObj
      );
    },
    copyText: function(flashcard, side) {
      if (side === 0) {
        // front
        flashcard.front = this.flashcardEditorSelectText;
      } else {
        // back
        flashcard.back = this.flashcardEditorSelectText;
      }
      this.$emit("flashcardOnSelect", "");
    }
  },
  destroyed() {}
};
</script>

<style scoped lang="scss">
@import "src/css/vars.scss";
.new-name-text {
  line-height: 30px;
  padding-bottom: 15px;
}

.disabled,
.disabled .icon-button:hover {
  color: $button-on-click-color !important;
  cursor: default;
}

h3 {
  display: block;
  font-size: 1.17em;
  margin-left: 0;
  margin-right: 0;
  font-weight: bold;
}

.popup-flashcard-editor {
  width: 99vw;
  height: 290px;
  background: $background-color-dark;
  bottom: 0;
  // position: absolute;
  z-index: 11;
}

.popup-flashcard-editor-modal-view {
  position: absolute !important;
  width: 90vw;
  height: 350px;
  top: calc(50% - 169px);
  left: calc(50% - 45vw);
  border: 1px solid black;
  border-radius: 20px;
  padding-top: 15px;
  text-align: center;
}

.popup-flashcard-editor,
.popup-flashcard-editor-modal-view {
  position: relative;
  .flashcard-header-title {
    display: table;
    width: 100%;
    margin-bottom: 20px;
    margin-top: 10px;
    z-index: 5;
    .tr {
      display: table-row;
      height: 35px;

      .flashcarddeck-editor-title {
        text-align: left;
        display: table-cell;
        width: 81%;
        padding-left: 50px;
        padding-bottom: 2px;
        overflow: hidden;
        white-space: nowrap;
        font-size: 1.23em;
        font-weight: bold;

        .flashcard-deck-title {
          border-radius: 5px;
          border: 1px $border-color solid;
          padding: 5px;
          font-size: 12pt;
        }
      }

      .flashcard-right-tools {
        float: right;
        width: 200px;
        text-align: right;
        .flashcard-right-tool {
          display: table-cell;
          font-size: 25px;
          width: 25px;
          padding-right: 20px;
        }
      }
    }
  }

  .prev-flashcard-button {
    left: 0;
    position: absolute;
    margin-top: 50px;

    .prev-flashcard {
      width: 25px;
      height: 40px;
      background: rgba(0, 0, 0, 0.4);
      color: $flashcard-prev-next-color;
      i {
        padding: 12px 8px;
      }
    }

    .prev-flashcard:hover {
      background: rgba(0, 0, 0, 0.6);
      cursor: pointer;
    }

    .prev-flashcard:active {
      background: rgba(0, 0, 0, 0.8);
    }
  }
  .next-flashcard-button {
    right: 0;
    position: absolute;
    margin-top: 25px;

    .next-flashcard {
      width: 25px;
      height: 40px;
      background: rgba(0, 0, 0, 0.4);
      color: $flashcard-prev-next-color;

      i {
        padding: 12px 8px;
      }
    }

    .next-flashcard:hover {
      background: rgba(0, 0, 0, 0.6);
      cursor: pointer;
    }

    .next-flashcard:active {
      background: rgba(0, 0, 0, 0.8);
    }
  }

  .flashcards {
    width: 80vw;
    height: 200px;
    margin: 0 auto -70px auto;
    display: block;
    .icon-button {
      margin-left: 0;
      font-size: 25px;
    }

    .flashcard {
      width: 45%;
      float: left;
      position: relative;
    }

    .swap-cards {
      width: 10%;
      float: left;
      margin-top: 7vh;
      text-align: center;

      .small-text {
        display: block;
        font-size: 12px;
        margin-top: -10px;
      }
    }
  }

  .copy-color {
    color: $light-font-color;
  }

  .flashcard-textarea {
    text-align: center;
    border-radius: 15px;
    border: 1px solid black;
    padding-top: 20px;
    height: 150px;
    background: white;

    :disabled {
      background: white;
    }

    .flashcard-textarea-input {
      height: 115px;
      font-size: 11pt;
      width: 100%;
      border: none;
      resize: none;
      padding: 10px;
    }

    .flashcard-textarea-input:focus {
      outline: 0px !important;
    }

    .copy-text {
      position: absolute;
      top: calc(50% - 10px);
      left: calc(50% - 74px);
    }
  }

  .textarea-label {
    position: absolute;
    right: 15px;
    font-size: 8pt;
    top: 5px;
    font-weight: bold;
    z-index: 200;
    color: $dark-font-color-lightest;
  }

  .flashcard-footer {
    display: table;
    width: 100%;
    background: $background-color-dark;
    margin-top: 40px;

    .tr {
      display: table-row;
      text-align: center;

      .page-counter {
        display: table-cell;
        text-align: center;
        width: 20%;
      }

      .empty {
        display: table-cell;
        width: 40%;
      }

      .save-and-close {
        text-align: right;
        display: table-cell;
        padding-right: 30px;
      }
    }
  }
}

.popover-buttons {
  margin-top: 10px;
}

.delete-message {
  text-align: center;
}

@media screen and (min-device-width: 300px) and (max-device-width: 499px) {
  .modal .modal-content {
    width: 90vw;
    margin: 20% auto;
  }

  .popup-flashcard-editor {
    width: 98vw;

    .flashcards {
      width: 70vw;

      .swap-cards {
        width: 6%;
        margin-top: 8vh;

        .small-text {
          font-size: 8px;
        }
      }

      .icon-button {
        font-size: 18px;
      }
    }

    .flashcard-footer .tr .save-and-close {
      padding-right: 10px;
    }
  }

  .popup-flashcard-editor-modal-view {
    width: 88vw;
  }
}
</style>


